import axios, { AxiosResponse } from "axios";
import { LoginResponse } from "../../interfaces/auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export async function login(username: string, password: string): Promise<LoginResponse> {
    /*
        Login with Username and Password 
        Returns a response which includes a session token, site etc.
    */

    const params = new URLSearchParams();
    params.append("username", username);
    params.append("password", password);

    const response: AxiosResponse<LoginResponse> = await axios.post(
        `${API_BASE_URL}/auth/login`,
        params,
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        }
    );

    const session_token = response.data.access_token;
    const user_name = response.data.user.username;
    const user_tenant_name = response.data.user.tenant.tenant_name;
    const user_site_name = response.data.user.site.site_name;

    // Store session details
    sessionStorage.setItem("session_token", session_token);
    sessionStorage.setItem("user_name", user_name);
    sessionStorage.setItem("user_tenant_name", user_tenant_name);
    sessionStorage.setItem("user_site_name", user_site_name);

    return response.data;
}